var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuBiAnalyze = function SvgMenuBiAnalyze(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 18 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "menuBiAnalyze_svg__a",
    d: "M1.579 9.429h1.128c.872 0 1.579.706 1.579 1.579v3.699c0 .872-.707 1.579-1.58 1.579H1.58A1.58 1.58 0 0 1 0 14.706v-3.698c0-.873.707-1.58 1.579-1.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "menuBiAnalyze_svg__b",
    d: "M8.436 4.286h1.128c.872 0 1.579.707 1.579 1.579v8.842c0 .872-.707 1.579-1.58 1.579H8.437a1.58 1.58 0 0 1-1.579-1.58V5.866c0-.872.707-1.58 1.58-1.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "menuBiAnalyze_svg__c",
    d: "M15.293 0h1.128C17.293 0 18 .707 18 1.579v13.128c0 .872-.707 1.579-1.579 1.579h-1.128a1.58 1.58 0 0 1-1.579-1.58V1.58c0-.872.707-1.579 1.58-1.579"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "menuBiAnalyze_svg__d",
    width: 4.286,
    height: 6.857,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#menuBiAnalyze_svg__a"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "menuBiAnalyze_svg__e",
    width: 4.286,
    height: 12,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#menuBiAnalyze_svg__b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "menuBiAnalyze_svg__f",
    width: 4.286,
    height: 16.286,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#menuBiAnalyze_svg__c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeDasharray: "0,0",
    strokeWidth: 3.158,
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#menuBiAnalyze_svg__a",
    fill: "currentColor",
    mask: "url(#menuBiAnalyze_svg__d)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#menuBiAnalyze_svg__b",
    mask: "url(#menuBiAnalyze_svg__e)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#menuBiAnalyze_svg__c",
    mask: "url(#menuBiAnalyze_svg__f)"
  }))));
};
export default SvgMenuBiAnalyze;